var map = {
	"./audits.svg": "ab04",
	"./calendar.svg": "0730",
	"./category.svg": "d73e",
	"./dashboard.svg": "81ba",
	"./files.svg": "4994",
	"./issues.svg": "ec88",
	"./logout.svg": "67fa",
	"./measure.svg": "f0c1",
	"./reports.svg": "e5b9",
	"./resources.svg": "091c",
	"./responses.svg": "9378",
	"./settings.svg": "aa47",
	"./tasks.svg": "e9ac",
	"./unanswered-responses.svg": "a116",
	"./workTasks.svg": "57b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef65";